import { z } from 'zod';

export enum LookerEnv {
  PRODUCTION = 'production',
  STAGING = 'staging',
}

export const LookerEnvSchema = z.nativeEnum(LookerEnv);
